/**
 * This is a request processor file
 * @description Request processors are functions that modify requests in some way. All request processor functions
 * receive 'type', 'request', 'autoToken', 'token' and 'captchaAction' arguments and return the processed request.
 * @note Request processors can be chained so each subsequent processor will receive the request from the previous one.
 */

import {user_activity_trigger_events} from "Config/app";
import {auth_api_endpoints} from "Config/auth";
import {updateLastUserActivityTime} from "Core/helpers/userActivity";

/**
 * Update user activity on IO request
 * @note This is a request processor function.
 *
 * @param {string} type - Internal request type (see imported REQUEST_TYPE const).
 * @param {string} url - Request's URL.
 * @param {string} api - Request's API (see 'io_base_urls' io config value for available APIs).
 * @param {string} endpoint - Request's API endpoint (see 'io_base_urls' io config value for available APIs).
 * @param {{method: string, headers: Headers, body: any}} request - Request object created by build request functions.
 * @param {boolean} autoToken - If true, auth token will be retrieved from storage.
 * @param {string} token - Custom auth token used only if 'autoToken' is false.
 * @param {string} captchaAction - Some captcha implementations can accept an actions name to differentiate between
 * different captcha requests for analytic purposes. Use this argument to set the action name.
 * @return {Object} Processed request.
 */
const processRequest = (type, url, api, endpoint, request, autoToken, token, captchaAction) => {
	// IO request event
	if (user_activity_trigger_events.includes('iorequest')) {
		// Do not update user activity on authorized ping request
		// @note For authorized ping use a separate event called 'authorizedping' that will be handled below
		if (api !== auth_api_endpoints.authorized_ping.api && endpoint !== auth_api_endpoints.authorized_ping.path) {
			updateLastUserActivityTime();
		}
	}
	
	// Authorized ping event
	if (
		user_activity_trigger_events.includes('authorizedping') &&
		api === auth_api_endpoints.authorized_ping.api && endpoint === auth_api_endpoints.authorized_ping.path
	) {
		updateLastUserActivityTime();
	}
	
	return request;
}

export default processRequest;